// src/services/projectService.js
import API from './api';

export const getProjects = async () => {
  return await API.get('/projects');
};

export const getProjectById = async (id) => {
  return await API.get(`/projects/${id}`);
};

export const createProject = async (projectData) => {
  return await API.post('/projects', projectData);
};

export const updateProject = async (id, projectData) => {
  return await API.patch(`/projects/${id}`, projectData);
};

export const deleteProject = async (id) => {
  return await API.delete(`/projects/${id}`);
};
export const getTeamsForUser = async (userId) => {
  const response = await API.get(`/teams?member=${userId}`);
  return response.data;
};
export const createReport = async (reportData) => {
  const response = await API.post('/reports', reportData);
  return response.data;
};